@if (!creatingProfile) {
  <div class="dialog-wrapper">
    <h2 mat-dialog-title>
      {{ header$ | async }}
      <mat-icon inline class="close" (click)="closeDialog()">close</mat-icon>
    </h2>
    <mat-dialog-content>
      <p class="wall-content">
        {{ 'AUTH_WALL_MODAL.CONTENT' | translate: { business_center: (whitelabelBusinessCenterName$ | async) } }}
      </p>
    </mat-dialog-content>
    @if (partnerHasCustomLogin$ | async) {
      <mat-dialog-actions class="dialog-actions">
        <div class="login-actions wall-content">
          <button mat-raised-button color="primary" (click)="loginToVBCThroughSSO()" class="login-actions__login">
            @if (!loading) {
              <span>
                {{ 'NAVIGATION.MENU.LOGIN' | translate }}
              </span>
            }
            @if (loading) {
              <span>
                <mat-progress-spinner class="login-loading" mode="indeterminate" diameter="24"></mat-progress-spinner>
              </span>
            }
          </button>
        </div>
      </mat-dialog-actions>
    }
    @if ((partnerHasCustomLogin$ | async) === false) {
      <mat-dialog-actions class="dialog-actions">
        <form (ngSubmit)="login()" #logInForm="ngForm">
          <div class="wall-content">
            <button type="button" mat-raised-button color="primary" class="google-login" (click)="googleLogin()">
              <span style="display: flex">
                <img [src]="googleLogoSrc" />
                {{ 'AUTH_WALL_MODAL.LOGIN.LOG_IN_WITH_GOOGLE' | translate }}
              </span>
            </button>
          </div>
          <span class="or">or</span>
          <div class="wall-content">
            @if (isLocalStory) {
              <mat-form-field class="full-width-field" appearance="outline">
                <mat-label>Session Token</mat-label>
                <input
                  matInput
                  placeholder="Session Token ({{ environment | titlecase }})"
                  name="sessionToken"
                  [(ngModel)]="sessionToken"
                />
              </mat-form-field>
              <div class="or-within-group">
                <span class="or">or</span>
              </div>
            }
            <mat-form-field class="full-width-field" appearance="outline">
              <mat-label>{{ 'COMMON.FIELD_LABELS.EMAIL' | translate }}</mat-label>
              <input matInput ngModel required email type="email" name="email" [(ngModel)]="emailAddressLogin" />
              <mat-error>
                {{ 'NOTIFICATION_SETTINGS.EMAIL_VALIDATION' | translate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width-field" appearance="outline">
              <mat-label>
                {{ 'COMMON.FIELD_LABELS.PASSWORD' | translate }}
              </mat-label>
              <input
                matInput
                ngModel
                name="password"
                [(ngModel)]="passwordLogin"
                required
                [type]="hidePasswordLetters ? 'password' : 'text'"
              />
              <mat-icon matSuffix (click)="hidePasswordLetters = !hidePasswordLetters">
                {{ hidePasswordLetters ? 'visibility_off' : 'visibility' }}
              </mat-icon>
              <mat-error>
                {{ 'AUTH_WALL_MODAL.LOGIN.PASSWORD_REQUIRED' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="login-actions wall-content">
            <button
              type="submit"
              mat-raised-button
              color="primary"
              (click)="login()"
              class="login-actions__login"
              [disabled]="logInForm.invalid && !isLocalStory"
            >
              @if (!loading) {
                <span>
                  {{ 'NAVIGATION.MENU.LOGIN' | translate }}
                </span>
              }
              @if (loading) {
                <span>
                  <mat-progress-spinner class="login-loading" mode="indeterminate" diameter="24"></mat-progress-spinner>
                </span>
              }
            </button>
            <button type="button" class="signup-button" mat-button color="primary" (click)="setCreatingProfileTrue()">
              {{ 'AUTH_WALL_MODAL.CREATE_PROFILE.SIGN_UP' | translate }}
            </button>
          </div>
        </form>
      </mat-dialog-actions>
    }
    <!-- <img class="buildings-corner" [src]="buildingImgSrc" /> -->
  </div>
}

@if (creatingProfile && !formSubmitted) {
  <div class="dialog-wrapper">
    <h2 mat-dialog-title>
      {{ 'AUTH_WALL_MODAL.CREATE_PROFILE.SIGN_UP' | translate }}
      <mat-icon inline class="close" (click)="closeDialog()">close</mat-icon>
    </h2>
    <mat-dialog-actions class="dialog-actions">
      <div class="wall-content">
        <button mat-raised-button color="primary" class="google-login" (click)="googleLogin()">
          <img [src]="googleLogoSrc" />
          {{ 'AUTH_WALL_MODAL.CREATE_PROFILE.SIGN_UP_WITH_GOOGLE' | translate }}
        </button>
      </div>
      <span class="or">or</span>
      <form class="wall-content" #createProfileForm="ngForm" (ngSubmit)="submitCreateProfileForm()">
        <mat-form-field class="email" appearance="outline">
          <mat-label>{{ 'COMMON.FIELD_LABELS.EMAIL' | translate }}</mat-label>
          <input matInput ngModel required email name="email" type="email" [(ngModel)]="emailAddressSignUp" />
          <mat-error>
            {{ 'NOTIFICATION_SETTINGS.EMAIL_VALIDATION' | translate }}
          </mat-error>
        </mat-form-field>
      </form>
      <div class="signup-actions wall-content">
        <button
          mat-raised-button
          color="primary"
          class="signup-actions__signup"
          (click)="submitCreateProfileForm()"
          [disabled]="createProfileForm.invalid"
        >
          {{ 'AUTH_WALL_MODAL.CREATE_PROFILE.SIGN_UP' | translate }}
        </button>
        <button mat-button color="primary" (click)="setCreatingProfileFalse()">
          {{ 'AUTH_WALL_MODAL.CREATE_PROFILE.LOG_IN_INSTEAD' | translate }}
        </button>
      </div>
    </mat-dialog-actions>
  </div>
}

@if (creatingProfile && formSubmitted && !hasError) {
  <div class="dialog-wrapper">
    <h2 mat-dialog-title>
      {{ 'AUTH_WALL_MODAL.CREATE_PROFILE.COMPLETE' | translate }}
      <mat-icon inline class="close" (click)="closeDialog()">close</mat-icon>
    </h2>
    <mat-dialog-content>
      <div class="success">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path success-circle" cx="65.1" cy="65.1" r="62.1" />
          <polyline class="path check" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
        </svg>
        <p>{{ 'AUTH_WALL_MODAL.CREATE_PROFILE.SUCCESS' | translate }}</p>
      </div>
    </mat-dialog-content>
  </div>
}

@if (creatingProfile && formSubmitted && hasError) {
  <div class="dialog-wrapper">
    <h2 mat-dialog-title>
      {{ 'AUTH_WALL_MODAL.CREATE_PROFILE.HEADER_ERROR' | translate }}
      <mat-icon inline class="close" (click)="closeDialog()">close</mat-icon>
    </h2>
    <mat-dialog-content>
      <div class="error">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path error-circle" cx="65.1" cy="65.1" r="62.1" />
          <line class="path line" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
          <line class="path line" x1="95.8" y1="38" x2="34.4" y2="92.2" />
        </svg>
        <p>{{ errorMessage$ | async }}</p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="setCreatingProfileFalse()">
        {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
}
